<div class="nav-item" [hidden]="(isVisible$ | async) === false">
    <div>
        <hs-search-input></hs-search-input>
        <hs-search-results></hs-search-results>
    </div>
</div>